module.exports = __webpack_public_path__ + "static/media/418.8aca039e.webp";